import type { IntlShape } from 'react-intl'
import { getMaxGuestCount } from 'lib/offer/occupancyUtils'

export function getVillaCapacityText(intl: IntlShape, offer: App.VillaOffer | App.VillaOfferSummary) {
  if (!offer.lowestPricePackage) return ''

  const roomRate = offer.lowestPricePackage.roomRate
  if (!roomRate) {
    return ''
  }

  const roomType = offer.lowestPricePackage.roomType
  if (!roomType) {
    return ''
  }

  const capacity = getMaxGuestCount(roomRate.capacities)
  if (!capacity) return ''

  const hasBedrooms = !!roomType.numberOfBedrooms
  const hasBathrooms = !!roomType.numberOfBathrooms
  const guestCountLabel = intl.formatMessage(
    {
      id: 'R3019BzeZYCjSRIYIlGe',
      defaultMessage: '{guestCount, plural, one {# guest} other {# guests}}',
    },
    { guestCount: capacity },
  )
  const bedroomCountLabel = intl.formatMessage(
    {
      id: 'Dm_CF9Sswqlzy_KHQiT-',
      defaultMessage: '{bedroomCount, plural, one {# bedroom} other {# bedrooms}}',
    },
    { bedroomCount: roomType.numberOfBedrooms },
  )
  const bathroomCountLabel = intl.formatMessage(
    {
      id: 'nlGNE-akGqF7kc3Iaqf7',
      defaultMessage: '{bathroomCount, plural, one {# bathroom} other {# bathrooms}}',
    },
    { bathroomCount: roomType.numberOfBathrooms },
  )

  if (hasBedrooms && hasBathrooms) {
    return intl.formatMessage(
      {
        id: '0Z3jHIzfiAbwyB5XT3FB',
        defaultMessage: 'Up to {guestCountLabel} · {bedroomCountLabel} · {bathroomCountLabel}',
      },
      { guestCountLabel, bedroomCountLabel, bathroomCountLabel },
    )
  }

  if (hasBedrooms) {
    return intl.formatMessage(
      {
        id: 'GF8VRYgXNVKVXcip2nkv',
        defaultMessage: 'Up to {guestCountLabel} · {bedroomCountLabel}',
      },
      { guestCountLabel, bedroomCountLabel },
    )
  }

  if (hasBathrooms) {
    return intl.formatMessage(
      {
        id: 'uV8AvC22sdke0JphRf29',
        defaultMessage: 'Up to {guestCountLabel} · {bathroomCountLabel}',
      },
      { guestCountLabel, bathroomCountLabel },
    )
  }

  return intl.formatMessage(
    {
      id: '-RmGt1ZBw6xjkRPBABca',
      defaultMessage: 'Up to {guestCount, plural, one {# guest} other {# guests}}',
    },
    { guestCount: capacity },
  )
}
